module.exports = __webpack_public_path__ + "img/test-drive-dealership.c03c151e.svg";